import styles from './card.module.scss';
import React, {CSSProperties, useCallback, useState} from 'react';
import {classNames} from '../../support/classnames.ts';
import {useClickOutside} from '../../support/use_click_outside.ts';

interface OwnProps {
    toggle: React.ReactNode;
    children: React.ReactNode;
    style?: CSSProperties;
}

export function CardSelect({toggle, children, style}: OwnProps) {
    const [isOpen, setIsOpen] = useState(false);

    const ref = React.useRef<HTMLDivElement | null>(null);
    const closeCallback = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    useClickOutside(ref, closeCallback);
    return (
        <div
            onClick={() => setIsOpen(!isOpen)}
            ref={ref}
            style={style}
            className={classNames(styles.card, styles.card_select, styles.card_arrow, {
                [styles.open]: isOpen,
            })}
        >
            {toggle}
            <i className={'fa-light fa-chevron-down'} />

            {isOpen && <div className={styles.select_list}>{children}</div>}
        </div>
    );
}
